"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryBuilder = exports.sanitizeUrl = exports.getHeadersWithUserAgent = exports.isNode = exports.convertFiltersToQueryParams = exports.splitValuesIntoManyQueries = exports.splitValuesIntoManyQueryBuilders = exports.splitAndFetchPaginated = exports.splitAndFetch = exports.MAX_URL_LENGTH = exports.addModelToFormData = void 0;

var dcl_catalyst_commons_1 = require("dcl-catalyst-commons");

var Environment_1 = require("./Environment");

function addModelToFormData(model, form) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var _loop = function _loop(propertyName) {
    if (!model.hasOwnProperty(propertyName) || model[propertyName] === null || model[propertyName] === undefined) return "continue";
    var formKey = namespace ? "".concat(namespace, "[").concat(propertyName, "]") : propertyName;

    if (model[propertyName] instanceof Date) {
      form.append(formKey, model[propertyName].toISOString());
    } else if (model[propertyName] instanceof Array) {
      model[propertyName].forEach(function (element, index) {
        var tempFormKey = "".concat(formKey, "[").concat(index, "]");
        addModelToFormData(element, form, tempFormKey);
      });
    } else if (typeof model[propertyName] === 'object') {
      addModelToFormData(model[propertyName], form, formKey);
    } else {
      form.append(formKey, model[propertyName].toString());
    }
  };

  for (var propertyName in model) {
    var _ret = _loop(propertyName);

    if (_ret === "continue") continue;
  }

  return form;
}

exports.addModelToFormData = addModelToFormData;

function removeDuplicates(array) {
  return Array.from(new Set(array));
}
/**
 * This method performs one or more fetches to the given server, splitting query params into different queries to avoid exceeding the max length of urls
 */


exports.MAX_URL_LENGTH = 2048;

function splitAndFetch(_x) {
  return _splitAndFetch.apply(this, arguments);
}

function _splitAndFetch() {
  _splitAndFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var baseUrl, path, queryParams, fetcher, uniqueBy, options, queries, results, _iterator6, _step6, query, elements;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            baseUrl = _ref.baseUrl, path = _ref.path, queryParams = _ref.queryParams, fetcher = _ref.fetcher, uniqueBy = _ref.uniqueBy, options = _ref.options;
            // Adding default
            fetcher = fetcher !== null && fetcher !== void 0 ? fetcher : new dcl_catalyst_commons_1.Fetcher(); // Split values into different queries

            queries = splitValuesIntoManyQueries({
              baseUrl: baseUrl,
              path: path,
              queryParams: queryParams
            });
            results = new Map();
            _iterator6 = _createForOfIteratorHelper(queries);
            _context.prev = 5;

            _iterator6.s();

          case 7:
            if ((_step6 = _iterator6.n()).done) {
              _context.next = 15;
              break;
            }

            query = _step6.value;
            _context.next = 11;
            return fetcher.fetchJson(query, options);

          case 11:
            elements = _context.sent;
            // Group by unique property (if set), or add all of them to the map
            elements.forEach(function (element) {
              return results.set(uniqueBy ? element[uniqueBy] : results.size, element);
            });

          case 13:
            _context.next = 7;
            break;

          case 15:
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](5);

            _iterator6.e(_context.t0);

          case 20:
            _context.prev = 20;

            _iterator6.f();

            return _context.finish(20);

          case 23:
            return _context.abrupt("return", Array.from(results.values()));

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 17, 20, 23]]);
  }));
  return _splitAndFetch.apply(this, arguments);
}

exports.splitAndFetch = splitAndFetch;
var CHARS_LEFT_FOR_OFFSET = 7;
/**
 * This method performs one or more fetches to the given server, splitting query params into different queries to avoid exceeding the max length of urls
 * This method should be used if the result is paginated, and needs to be queries many times
 */

function splitAndFetchPaginated(_x2) {
  return _splitAndFetchPaginated.apply(this, arguments);
}

function _splitAndFetchPaginated() {
  _splitAndFetchPaginated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var fetcher, baseUrl, path, queryParams, elementsProperty, uniqueBy, options, reservedParams, queries, foundElements, exit, i, url, response, elements, nextRelative;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetcher = _ref2.fetcher, baseUrl = _ref2.baseUrl, path = _ref2.path, queryParams = _ref2.queryParams, elementsProperty = _ref2.elementsProperty, uniqueBy = _ref2.uniqueBy, options = _ref2.options;
            // Set default
            fetcher = fetcher !== null && fetcher !== void 0 ? fetcher : new dcl_catalyst_commons_1.Fetcher(); // Reserve a few chars to send the offset

            reservedParams = new Map([['offset', CHARS_LEFT_FOR_OFFSET]]); // Split values into different queries

            queries = splitValuesIntoManyQueries({
              baseUrl: baseUrl,
              path: path,
              queryParams: queryParams,
              reservedParams: reservedParams
            }); // Perform the different queries

            foundElements = new Map();
            exit = false;
            i = 0;

          case 7:
            if (!(i < queries.length && !exit)) {
              _context2.next = 28;
              break;
            }

            url = queries[i];

          case 9:
            if (!(url && !exit)) {
              _context2.next = 25;
              break;
            }

            _context2.prev = 10;
            _context2.next = 13;
            return fetcher.fetchJson(url, options);

          case 13:
            response = _context2.sent;
            elements = response[elementsProperty];
            elements.forEach(function (element) {
              return foundElements.set(element[uniqueBy], element);
            });
            nextRelative = response.pagination.next;
            url = nextRelative ? new URL(nextRelative, url).toString() : undefined;
            _context2.next = 23;
            break;

          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](10);
            exit = true;

          case 23:
            _context2.next = 9;
            break;

          case 25:
            i++;
            _context2.next = 7;
            break;

          case 28:
            return _context2.abrupt("return", Array.from(foundElements.values()));

          case 29:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[10, 20]]);
  }));
  return _splitAndFetchPaginated.apply(this, arguments);
}

exports.splitAndFetchPaginated = splitAndFetchPaginated;

function splitValuesIntoManyQueryBuilders(_ref3) {
  var queryParams = _ref3.queryParams,
      baseUrl = _ref3.baseUrl,
      path = _ref3.path,
      reservedParams = _ref3.reservedParams;
  var queryParamsMap = 'name' in queryParams ? new Map([[queryParams.name, queryParams.values]]) : queryParams; // Check that it makes sent to apply the algorithm

  if (queryParamsMap.size === 0) {
    return [new QueryBuilder(baseUrl + path, queryParamsMap, reservedParams)];
  } // Remove duplicates


  var withoutDuplicates = Array.from(queryParamsMap.entries()).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        name = _ref5[0],
        values = _ref5[1];

    return [name, removeDuplicates(values)];
  }); // Sort params by amount of values

  var sortedByValues = withoutDuplicates.sort(function (_ref6, _ref7) {
    var _ref8 = _slicedToArray(_ref6, 2),
        _ = _ref8[0],
        values1 = _ref8[1];

    var _ref9 = _slicedToArray(_ref7, 2),
        __ = _ref9[0],
        values2 = _ref9[1];

    return values1.length - values2.length;
  }); // Add all params (except the last one that is the one with the most values) into the url

  var defaultQueryBuilder = new QueryBuilder(baseUrl + path, new Map(), reservedParams);

  for (var i = 0; i < sortedByValues.length - 1; i++) {
    var _sortedByValues$i = _slicedToArray(sortedByValues[i], 2),
        paramName = _sortedByValues$i[0],
        paramValues = _sortedByValues$i[1];

    if (!defaultQueryBuilder.canSetParams(paramName, paramValues)) {
      throw new Error("This library can split one query param into many HTTP requests, but it can't split more than one. You will need to do that on the client side.");
    }

    defaultQueryBuilder.setParams(paramName, paramValues);
  } // Prepare everything


  var queryBuilder = QueryBuilder.clone(defaultQueryBuilder);

  var _sortedByValues = _slicedToArray(sortedByValues[sortedByValues.length - 1], 2),
      lastParamName = _sortedByValues[0],
      lastParamValues = _sortedByValues[1];

  var result = [];

  var _iterator = _createForOfIteratorHelper(lastParamValues),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;

      // Check url length
      if (!queryBuilder.canAddParam(lastParamName, value)) {
        result.push(queryBuilder);
        queryBuilder = QueryBuilder.clone(defaultQueryBuilder);
      }

      queryBuilder.addParam(lastParamName, value);
    } // Add current builder one last time

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  result.push(queryBuilder);
  return result;
}

exports.splitValuesIntoManyQueryBuilders = splitValuesIntoManyQueryBuilders;

function splitValuesIntoManyQueries(parameters) {
  var builders = splitValuesIntoManyQueryBuilders(parameters);
  return builders.map(function (builder) {
    return builder.toString();
  });
}

exports.splitValuesIntoManyQueries = splitValuesIntoManyQueries;

function convertFiltersToQueryParams(filters) {
  if (!filters) {
    return new Map();
  }

  var entries = Object.entries(filters).filter(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
        _ = _ref11[0],
        value = _ref11[1];

    return !!value;
  }).map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
        name = _ref13[0],
        value = _ref13[1];

    var newName = name.endsWith('s') ? name.slice(0, -1) : name;
    var newValues; // Force coersion of number, boolean, or string into string

    if (Array.isArray(value)) {
      newValues = _toConsumableArray(value).filter(isValidQueryParamValue).map(function (_) {
        return "".concat(_);
      });
    } else if (isValidQueryParamValue(value)) {
      newValues = ["".concat(value)];
    } else {
      throw new Error('Query params must be either a string, a number, a boolean or an array of the types just mentioned');
    }

    return [newName, newValues];
  }).filter(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 2),
        _ = _ref15[0],
        values = _ref15[1];

    return values.length > 0;
  });
  return new Map(entries);
}

exports.convertFiltersToQueryParams = convertFiltersToQueryParams;

function isNode() {
  return typeof window === 'undefined' || !isBlobAvailable();
}

exports.isNode = isNode;

function getHeadersWithUserAgent(client) {
  return isNode() ? {
    'User-Agent': "".concat(client, "/").concat(Environment_1.RUNNING_VERSION, " (+https://github.com/decentraland/catalyst-client)")
  } : undefined;
}

exports.getHeadersWithUserAgent = getHeadersWithUserAgent;

function isBlobAvailable() {
  try {
    new Blob();
    return true;
  } catch (_a) {
    return false;
  }
}

function isValidQueryParamValue(value) {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
}
/** Remove white spaces and add https if no protocol is specified */


function sanitizeUrl(url) {
  // Remove empty spaces
  url = url.trim(); // Add protocol if necessary

  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    url = 'https://' + url;
  } // Remove trailing slash if present


  if (url.endsWith('/')) {
    url = url.slice(0, -1);
  }

  return url;
}

exports.sanitizeUrl = sanitizeUrl;

var QueryBuilder = /*#__PURE__*/function () {
  function QueryBuilder(baseUrl) {
    var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
    var reservedParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Map();

    _classCallCheck(this, QueryBuilder);

    this.baseUrl = baseUrl;
    this.queryParams = queryParams;
    this.reservedParams = reservedParams;
    this.length = this.calculateUrlLength(queryParams, reservedParams);
  }

  _createClass(QueryBuilder, [{
    key: "canAddParam",
    value: function canAddParam(paramName, paramValue) {
      return this.length + paramName.length + paramValue.length + 2 < exports.MAX_URL_LENGTH;
    }
  }, {
    key: "addParam",
    value: function addParam(paramName, paramValue) {
      var _a;

      if (!this.canAddParam(paramName, paramValue)) {
        throw new Error("You can't add this parameter '".concat(paramName, "', since it would exceed the max url length"));
      }

      var values = (_a = this.queryParams.get(paramName)) !== null && _a !== void 0 ? _a : [];
      values.push(paramValue);
      this.queryParams.set(paramName, values);
      this.length += this.calculateAddedLength(paramName, [paramValue]);
      return this;
    }
  }, {
    key: "canSetParams",
    value: function canSetParams(paramName, paramValues) {
      var newQueryParams = new Map([].concat(_toConsumableArray(this.queryParams), [[paramName, paramValues]]));
      var newLength = this.calculateUrlLength(newQueryParams, this.reservedParams);
      return newLength < exports.MAX_URL_LENGTH;
    }
    /** This action will override whatever configuration there was previously for the given query parameter */

  }, {
    key: "setParams",
    value: function setParams(paramName, paramValues) {
      if (!this.canSetParams(paramName, paramValues)) {
        throw new Error("You can't add this parameter '".concat(paramName, "', since it would exceed the max url length"));
      }

      this.queryParams.set(paramName, paramValues.map(function (value) {
        return "".concat(value);
      }));
      this.length = this.calculateUrlLength(this.queryParams, this.reservedParams);
      return this;
    }
    /** This action will override whatever configuration there was previously for the given query parameter */

  }, {
    key: "setParam",
    value: function setParam(paramName, paramValue) {
      this.setParams(paramName, [paramValue]);
      return this;
    }
  }, {
    key: "toString",
    value: function toString() {
      var url = this.baseUrl;
      var addedParamAlready = false;

      var _iterator2 = _createForOfIteratorHelper(this.queryParams),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              paramName = _step2$value[0],
              paramValues = _step2$value[1];

          var _iterator3 = _createForOfIteratorHelper(paramValues),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var paramValue = _step3.value;

              if (addedParamAlready) {
                url += "&".concat(paramName, "=").concat(paramValue);
              } else {
                url += "?".concat(paramName, "=").concat(paramValue);
                addedParamAlready = true;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return url;
    }
  }, {
    key: "calculateUrlLength",
    value: function calculateUrlLength(queryParams, reservedParams) {
      var length = this.baseUrl.length;

      var _iterator4 = _createForOfIteratorHelper(reservedParams),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              paramName = _step4$value[0],
              reserved = _step4$value[1];

          if (!this.queryParams.has(paramName)) {
            // We will avoid the reserved parameters that already have a value set
            length += paramName.length + 2 + reserved;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(queryParams),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              _paramName = _step5$value[0],
              paramValues = _step5$value[1];

          length += this.calculateAddedLength(_paramName, paramValues);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return length;
    }
  }, {
    key: "calculateAddedLength",
    value: function calculateAddedLength(paramName, paramValues) {
      var valuesLength = this.calculateArrayLength(paramValues);
      return valuesLength + (paramName.length + 2) * paramValues.length;
    }
  }, {
    key: "calculateArrayLength",
    value: function calculateArrayLength(array) {
      return array.map(function (value) {
        return "".concat(value);
      }).reduce(function (accum, curr) {
        return accum + curr.length;
      }, 0);
    }
  }], [{
    key: "clone",
    value: function clone(queryBuilder) {
      return new QueryBuilder(queryBuilder.baseUrl, new Map(queryBuilder.queryParams), queryBuilder.reservedParams);
    }
  }]);

  return QueryBuilder;
}();

exports.QueryBuilder = QueryBuilder;